import React from 'react';
import AdminHeader from './AdminHeader'
const Edit = (props) => {
    return (
        <div>
            <AdminHeader></AdminHeader>
            <h3>This is Edit Product</h3>
        </div>
    );
};

export default Edit;